import api from '@/api/dy/createDynamic'
const state = {
	userInfo: {},
	videolist:{
		list:[]
	}
}
const mutations = {
	getVideolist(state, data) {
		state.videolist = data
	},
}
const actions = {
	getTacode({ commit }, params = {}) {
		return api.getTacode(params)
	},
	taCodeList({ commit }, params = {}) {
		return api.taCodeList(params)
	},
	acaddvideo({ commit }, params = {}) {
		return api.addvideo(params)
	},
	deletevideo({ commit }, params = {}) {
		return api.deletevideo(params)
	},
	async acvideolist({ commit }, params = {}) {
		let list = await api.videolist(params)
		commit('getVideolist',list)
	},
}
export default {
	namespaced:true,
	state,
	mutations,
	actions,
}